import React from 'react';
import clsx from 'clsx';

type DotLoaderProps = {
  size?: number;
  gap?: number;
  durationMs?: number;
  risePx?: number;
  className?: string;
  colorClassName?: string;
  ariaLabel?: string;
};

export default function DotLoader({
  size = 6,
  gap = 6,
  durationMs = 1000,
  risePx = 3,
  className,
  colorClassName = 'text-gray-600 dark:text-gray-300',
  ariaLabel = 'Yükleniyor',
}: DotLoaderProps) {
  return (
    <div
      className={clsx('inline-flex items-center', colorClassName, className)}
      role="status"
      aria-live="polite"
      aria-label={ariaLabel}
      style={
        {
          '--dot-size': `${size}px`,
          '--dot-gap': `${gap}px`,
          '--dot-rise': `${risePx}px`,
          '--dot-duration': `${durationMs}ms`,
        } as React.CSSProperties
      }
    >
      <div className="dots">
        <span />
        <span />
        <span />
      </div>

      <style jsx>{`
        .dots {
          display: inline-flex;
          align-items: center;
          gap: var(--dot-gap);
          line-height: 1;
        }
        .dots span {
          width: var(--dot-size);
          height: var(--dot-size);
          border-radius: 50%;
          background: currentColor;
          opacity: 0.25;
          animation: dotty var(--dot-duration) infinite ease-in-out;
        }
        .dots span:nth-child(2) {
          animation-delay: calc(var(--dot-duration) * 0.15);
        }
        .dots span:nth-child(3) {
          animation-delay: calc(var(--dot-duration) * 0.3);
        }
        @keyframes dotty {
          0% {
            opacity: 0.25;
            transform: translateY(0);
          }
          20% {
            opacity: 1;
            transform: translateY(calc(var(--dot-rise) * -1));
          }
          40%,
          100% {
            opacity: 0.25;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}

export function DotEllipsis({
  className,
  colorClassName = 'text-gray-600 dark:text-gray-300',
}: {
  className?: string;
  colorClassName?: string;
}) {
  return <span className={clsx('select-none', colorClassName, className)}>...</span>;
}
